export type PageWithParent = {
  slug?: string | null;
  parent?: PageWithParent | null;
};

export type InternalUrlRecord = {
  __typename?: string;
  slug?: string | null;
  parent?: PageWithParent | null;
};

export function getParentSlugs(page: PageWithParent): string[] {
  if (!page.parent?.slug) {
    return [];
  }

  return [...getParentSlugs(page.parent), page.parent.slug];
}

export function getPagePath(page: PageWithParent): string {
  const slug = page.slug?.trim();

  if (!slug || slug === 'home') {
    return '/';
  }

  return `/${[...getParentSlugs(page), slug].join('/')}`;
}

export function normalizePagePath(path: string): string {
  if (!path || path === '/') {
    return '/';
  }

  return path.replace(/\/+$/, '');
}

export function pagePathMatches(
  page: PageWithParent,
  requestedPath: string
): boolean {
  return (
    normalizePagePath(getPagePath(page)) === normalizePagePath(requestedPath)
  );
}

export function getLeafSlugFromPath(pathSegments: string[]): string | null {
  const leafSlug = pathSegments.at(-1)?.trim();

  return leafSlug || null;
}

export function getRequestedPath(pathSegments: string[]): string {
  if (pathSegments.length === 0) {
    return '/';
  }

  return `/${pathSegments.join('/')}`;
}

export function shouldRedirectFlatPageUrl(
  page: PageWithParent,
  pathSegments: string[],
  requestedPath: string
): boolean {
  if (pagePathMatches(page, requestedPath)) {
    return false;
  }

  const expectedPath = normalizePagePath(getPagePath(page));

  return pathSegments.length === 1 && expectedPath.includes('/');
}

export function resolveInternalUrl(
  internalUrl: InternalUrlRecord | null | undefined
): string {
  if (!internalUrl?.slug) {
    return '/';
  }

  if (internalUrl.__typename === 'ProjectRecord') {
    return `/projekte/${internalUrl.slug}`;
  }

  return getPagePath(internalUrl);
}
